import React, { useContext } from "react";
import { CreateView, IndexView, ShowView } from "lego-gui-lib/lib";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import {
  languageSelectionChoiceContext,
  LanguageSelectionChoiceSchema,
  LanguageSelectionChoiceSchemaColumns
} from "./schema";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router";

export const CreateLanguageSelectionChoice = observer(({ ...rest }: any) => {
  const i18n = useTranslation();
  const languageSelectionChoice = useContext(languageSelectionChoiceContext);
  const match = useRouteMatch();

  const title = i18n.t("common:create", {
    domain: "hns:languageSelectChoice:domain"
  });
  const baseUrl = match.url;
  const parentTitle = i18n.t("common:edit", {
    domain: "hns:languageSelect:domain"
  });
  const parentUrl = baseUrl.substring(0, baseUrl.lastIndexOf("/"));
  const id = {
    // @ts-ignore
    id: match.params.choiceId
  };
  const history = useHistory();

  return (
    <>
      <BreadcrumbsItem to={parentUrl}>{parentTitle}</BreadcrumbsItem>
      <BreadcrumbsItem to={baseUrl}>{title}</BreadcrumbsItem>
      <CreateView
        dataSource={languageSelectionChoice.oneDataSource}
        {...rest}
        title={title}
        goBack={() => history.goBack()}
        fields={LanguageSelectionChoiceSchemaColumns}
        id={id.id ? id : undefined}
      />
    </>
  );
});

export const ShowLanguageSelectionChoice = observer(() => {
  const i18n = useTranslation();
  const languageSelectionChoice = useContext(languageSelectionChoiceContext);
  const match = useRouteMatch();
  const history = useHistory();

  const title = i18n.t("common:edit", {
    domain: "hns:languageSelectChoice:domain"
  });
  const baseUrl = match.url;
  const id = {
    // @ts-ignore
    id: match.params.choiceId
  };
  const parentTitle = i18n.t("common:edit", {
    domain: "hns:languageSelect:domain"
  });
  const parentUrl = baseUrl.substring(0, baseUrl.lastIndexOf("/"));

  return (
    <>
      <BreadcrumbsItem to={parentUrl}>{parentTitle}</BreadcrumbsItem>
      <BreadcrumbsItem to={baseUrl}>{title}</BreadcrumbsItem>
      <ShowView
        dataSource={languageSelectionChoice.oneDataSource}
        title={title}
        goBack={() => history.goBack()}
        fields={LanguageSelectionChoiceSchema}
        id={id}
      />
    </>
  );
});

const toolbarButtons = (allowed: boolean) => {
  return allowed
    ? { delete: true, export: true }
    : { delete: false, export: true };
};

const rowButtons = (allowed: boolean) => {
  return allowed
    ? { edit: true, delete: true, copy: true, export: true }
    : { edit: false, delete: false, copy: false, export: false };
};

const titleButtons = (allowed: boolean) => (props: any) => {
  if (allowed && props.dataSource?.list?.length < 12) {
    return undefined;
  } else {
    return <></>;
  }
};

export const LanguageSelectionChoiceIndex = observer((props: any) => {
  const i18n = useTranslation();
  const title = i18n.t("hns:languageSelectChoice:domain_plural");

  const { isAllowed, ...rest } = props;
  const languageSelectionChoice = useContext(languageSelectionChoiceContext);

  return (
    <>
      <IndexView
        {...rest}
        dataSource={languageSelectionChoice.listDataSource}
        titleButtons={titleButtons(isAllowed)}
        toolbarButtons={toolbarButtons(isAllowed)}
        rowButtons={rowButtons(isAllowed)}
        title={title}
        baseUrl="/choices"
        columns={LanguageSelectionChoiceSchema}
      />
    </>
  );
});
